import { render, staticRenderFns } from "./customerAccountBox.vue?vue&type=template&id=15415ed9&"
import script from "./customerAccountBox.vue?vue&type=script&lang=ts&"
export * from "./customerAccountBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports